import script from "./EditMyVacancy.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMyVacancy.vue?vue&type=script&setup=true&lang=js"

import "./EditMyVacancy.vue?vue&type=style&index=0&id=bcf3c6e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcf3c6e2"]])

export default __exports__